<template>
    <div class="a-form-inputs a-form-inputs--table">
        <form @submit.prevent>
            <accordion>
                <general-damages estate-type="estate"></general-damages>
                <past-cost-of-care estate-type="estate"></past-cost-of-care>
                <past-cost-of-travel estate-type="estate"></past-cost-of-travel>
                <past-loss-of-earnings estate-type="estate"></past-loss-of-earnings>
            </accordion>

            <step-button :next-valid="allValid"></step-button>
        </form>
    </div>
</template>

<script>
    import {setStepValid} from 'services/routingMethods';
    import StepButton from 'components/StepButton.vue';
    import {mapGetters, mapActions} from 'vuex';
    import Accordion from 'components/accordion/Accordion';
    import GeneralDamages from 'pages/fatal-accident-claims/cru-benefits/GeneralDamages'
    import PastCostOfCare from 'pages/fatal-accident-claims/cru-benefits/PastCostOfCare'
    import PastCostOfTravel from 'pages/fatal-accident-claims/cru-benefits/PastCostOfTravel'
    import PastLossOfEarnings from 'pages/fatal-accident-claims/cru-benefits/PastLossOfEarnings'

    export default {
        components: {
            Accordion,
            StepButton,
            GeneralDamages,
            PastCostOfCare,
            PastCostOfTravel,
            PastLossOfEarnings
        },
        computed: mapGetters('fatal/estate/cru', ['allValid']),
        mounted() {
            setStepValid(this.allValid);
        },
        watch: {
            allValid() {
                this.update();
            }
        },
        methods: {
            ...mapActions('fatal/estate/headsOfLoss', ['calcAllInterest']),
            update() {
                setStepValid(this.allValid);
                if (this.allValid) {
                    this.calcAllInterest();
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CruBenefits.vue?36f7febf